var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"iwimage",style:({ height: _vm.imageHeight,  width: _vm.imageWidth, top: _vm.imageTop, visibility: _vm.imageVisibility}),attrs:{"id":"imageAsset","src":_vm.imageAsset},on:{"load":_vm.onImgLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }